import {
    THEME_SET_USER_DATA
} from "../actions/themeActions";

const initialState = {
    userInfo: {}
};

const themeReducer = (state = initialState, action) => {
    switch (action.type) {
        case THEME_SET_USER_DATA:
            return {
                ...state,
                userInfo: action.payload
            };
        default:
            return state;
    }
};

export default themeReducer;